import { useLookup } from "@rentablo/api/apiv1";
import type { DateValuePair } from "@rentablo/api/apiv1";

export const useHistoricQuoteLookupPerYear = (
  quoteProvider?: string,
  tickerSymbol?: string,
  from?: string,
  { enabled = true }: { enabled?: boolean } = { enabled: true }
) => {
  const query = useLookup(
    {
      tickerSymbol: tickerSymbol!,
      quoteProvider: quoteProvider!,
      from,
      intervalPosition: "last",
      interval: "year",
    },
    {
      enabled: !!quoteProvider && !!tickerSymbol && enabled,
    }
  );

  return {
    ...query,
    data: query.data?.historicQuotes?.[tickerSymbol!] as
      | DateValuePair[]
      | undefined,
  };
};

export const useHistoricQuotesLookupPercent = (
  quoteProvider?: string,
  tickerSymbol?: string,
  from?: string
) => {
  const query = useLookup(
    {
      tickerSymbol: tickerSymbol!,
      quoteProvider: quoteProvider!,
      from,
      inPercentFrom: "currentToNow",
      intervalPosition: "current",
      interval: "year",
    },
    {
      enabled: !!quoteProvider && !!tickerSymbol,
    }
  );

  return {
    ...query,
    data: query.data?.historicQuotes?.[tickerSymbol!] as
      | DateValuePair[]
      | undefined,
  };
};
